import { ShimmerText } from '@/components/feedback/shimmer-text';
import { useCopilotTool } from '@customerio/hydra-copilot/react';
import { Text } from '@customerio/pluma-components/react';
import { MessageContainer } from '../../components/primitives/message-container';

export function SearchDocumentation() {
  useCopilotTool({
    type: 'server',
    name: 'search_documentation',
    render({ status }) {
      if (status === 'executing') {
        return (
          <MessageContainer variant="model">
            <ShimmerText>Searching documentation...</ShimmerText>
          </MessageContainer>
        );
      }

      if (status === 'error') {
        return (
          <MessageContainer variant="model">
            <Text color="critical">We hit an issue with the documentation search</Text>
          </MessageContainer>
        );
      }

      return null;
    },
  });

  return null;
}
